import { getRequest, getWithParamsRequest } from '../../../api/utils/provider';
import { ApiResponse } from '../../../api/utils/responseTransform';
import { Contact, MustBeMetProtolsQueryParams, ProtocolOption } from '../../features/MustBeMetProtocolForm/types';

export async function getMustBeMetProtocols(
  queryParams: MustBeMetProtolsQueryParams
): Promise<ApiResponse<{ locationProtocols: ProtocolOption[] }>> {
  return getWithParamsRequest('location_protocols/protocol_options/', queryParams);
}

export async function getPassengerCaregivers(passengerId): Promise<
  ApiResponse<{
    caregiverContacts: Contact[];
  }>
> {
  return getRequest(`passengers/${passengerId}/caregiver_contacts`);
}

export async function getSchoolContacts(queryParams): Promise<
  ApiResponse<{
    data: { name: string; phone: string; id: number }[];
  }>
> {
  return getWithParamsRequest('schools', queryParams);
}
